export default __webpack_public_path__ + "static/NotoSans-Bold.subset-85b1df39c3acf743e730097678d9b77e.woff2";